import React, { ReactNode } from 'react';
import { SetupArea } from 'nekst-api';
import SetupAreasStateBreadcrumbs from './SetupAreasStateBreadcrumbs';
import { Breadcrumb } from '../../../shared/web/layout/Breadcrumbs';
import useSettingsNavigator from '../../settingsNavigator';

export function SetupAreaBreadcrumbs(props: {
  children?: ReactNode,
  setupArea: SetupArea,
})
{
  const setupArea = props.setupArea;

  const settingsNavigator = useSettingsNavigator();

  return (
    <SetupAreasStateBreadcrumbs state={setupArea.market?.state}>
      <Breadcrumb
        text={setupArea.name}
        href={settingsNavigator.getAdminSetupAreaPageLink(
          setupArea.market?.state,
          setupArea.id
        )}
      >
        {props.children}
      </Breadcrumb>
    </SetupAreasStateBreadcrumbs>
  );
}

export function SetupAreaVersionBreadcrumbs(props: {
  children?: ReactNode,
  setupArea: SetupArea,
  version: string
}) {
  const setupAreaVersion = props.setupArea.versions.find(
    (version) => version.version === props.version
  );

  const settingsNavigator = useSettingsNavigator();

  const setupArea = props.setupArea;

  if (setupAreaVersion) {
    return (
      <SetupAreaBreadcrumbs setupArea={props.setupArea}>
        <Breadcrumb
          text={setupAreaVersion.version}
          href={settingsNavigator.getAdminSetupAreaVersionPageLink(
            setupArea.market?.state,
            setupArea.id,
            setupAreaVersion.version
          )}
        >
          {props.children}
        </Breadcrumb>
      </SetupAreaBreadcrumbs>
    );
  } else {
    return null;
  }
}
